<template>
  <div class="headerWrap" :class="{ hiddenSp: sm === false }">
    <header class="header u-containar">
      <div class="header_left">
        <router-link to="/" class="header_logo">
          <picture>
            <source
              media="(max-width: 899px)"
              srcset="@/assets/images/common/logo-header.svg"
            />
            <img
              src="@/assets/images/common/logo-header-outline.png"
              alt="未来のドクターへ、期待以上の出会いを。マイナビ RESIDENT"
            />
          </picture>
        </router-link>
        <ul class="header_menu">
          <li
            :class="{ active: '/mypage/document_request/list' === $route.path }"
          >
            <button
              type="button"
              @click="
                $store.dispatch(
                  'moveLimitedPage',
                  '/mypage/document_request/list'
                )
              "
            >
              予約・申込
            </button>
          </li>
          <li :class="{ active: '/mypage/bookmark/list' === $route.path }">
            <button
              type="button"
              @click="
                $store.dispatch('moveLimitedPage', '/mypage/bookmark/list')
              "
            >
              お気に入り
            </button>
          </li>
          <li>
            <button type="button" @click="$store.dispatch('showSearchModal')">
              検索
            </button>
          </li>
          <li :class="{ active: '/events/list' === $route.path }">
            <button type="button" @click="$router.push('/events/list')">
              イベント
            </button>
          </li>
          <li :class="{ active: '/mypage' === $route.path }">
            <button
              type="button"
              @click="$store.dispatch('moveLimitedPage', '/mypage')"
            >
              マイページ
            </button>
          </li>
        </ul>
      </div>
      <div v-if="$store.state.isLogin" class="headerWelcome">
        <img src="@/assets/images/icon/user.svg" alt="" />
        <p>ようこそ、{{ formatName($store.state.userInfo.name_sei) }}さん</p>
      </div>
      <ul v-if="!$store.state.isLogin" class="headerNav">
        <li>
          <IconButton path="/login" label="ログイン" icon="login" />
        </li>
        <li class="icon-note">
          <IconButton
            path="/register/user_category"
            label="会員登録"
            icon="note"
          />
        </li>
      </ul>
    </header>
    <GlobalNav />
  </div>
</template>

<script lang="ts">
import IconButton from '@/components/elements/IconButton.vue'
import GlobalNav from '@/components/genenral/GlobalNav.vue'

export default {
  name: 'Header',

  props: {
    sm: {
      type: Boolean,
      default: true
    }
  },

  components: {
    GlobalNav,
    IconButton
  },

  setup() {
    const formatName = (name: string) => {
      return name.length > 8 ? name.slice(0, 8) + '…' : name
    }
    return {
      formatName
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.headerWrap {
  z-index: 10;
  position: relative;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  background-color: #fff;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 68px;
  line-height: 1.4;
  font-weight: 500;
  padding-left: 16px;
  padding-right: 16px;
  @include mixins.media() {
    padding-right: 20px;
    padding-left: 20px;
    .header_left {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
  }
}

.header_logo {
  display: block;
  width: 152px;

  @include mixins.media() {
    width: 210px;
  }

  img {
    display: block;
  }
}

.header_menu {
  display: none;

  @include mixins.media() {
    margin-left: 40px;
    display: flex;

    @include mixins.media('lg') {
      margin-left: 50px;
    }
  }

  > li {
    &.active {
      color: var.$color-main-text;
    }

    &:not(:first-child) {
      margin-left: 30px;

      @include mixins.media('lg') {
        margin-left: 40px;
      }
    }
  }
}

.headerNav {
  display: flex;
  align-items: center;

  > li {
    &:not(:first-child) {
      margin-left: 30px;
    }

    button::v-deep {
      @include mixins.media('lg') {
        display: flex;
        align-items: center;
        > img {
          width: 22px;
        }
        > .iconButton_label {
          font-weight: normal;
          margin-top: 0;
          font-size: 14px;
          margin-left: 10px;
        }
      }
    }
  }

  .icon-note::v-deep .iconButton_label {
    margin-top: 7px;
    @include mixins.media('lg') {
      margin-top: 0;
    }
  }
}

.headerWrap.is-login {
  .header {
    height: 40px;
    @include mixins.media() {
      height: 72px;
    }
  }
}

.globalNav {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 55px;
  padding-bottom: 10px;
  background-color: var.$color-main;
  color: #fff;

  > li {
    flex-basis: 20%;
    flex-grow: 1;
  }

  .icon-menu::v-deep .iconButton_label {
    margin-top: 9px;
  }
}

.headerWelcome {
  font-size: 1.1rem;
  margin-left: 16px;
  img {
    display: none;
  }
  @include mixins.media() {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    margin-left: 40px;

    img {
      display: block;
      margin-right: 10px;
    }
  }
}
</style>
